import { Alert } from "@mantine/core";

export const AlertOverwrite = Alert.extend({
  classNames: {
    root: "mapka-alert",
  },
  vars: ({ primaryColor }, props) => {
    const {
      color = primaryColor,
      variant = "light",
    } = props;

    const rootVars: Record<string, string> = {};

    if (variant === "light") {
      rootVars["--alert-bg"] = `light-dark(var(--mantine-color-${color}-light), var(--mantine-color-${color}-filled))`;
      rootVars["--alert-color"] = "light-dark(black, white)";
    }
    else if (variant === "filled") {
      rootVars["--alert-bg"] = `var(--mantine-color-${color}-filled)`;
      rootVars["--alert-color"] = "light-dark(black, white)";
    }
    else if (variant === "outline") {
      rootVars["--alert-bg"] = "var(--mantine-color-body)";
      rootVars["--alert-color"] = "var(--mantine-color-text)";
      rootVars["--alert-title-color"] = `var(--mantine-color-${color}-text)`;
    }
    else if (variant === "default") {
      rootVars["--alert-bg"] = "transparent";
      rootVars["--alert-color"] = "var(--mantine-color-text)";
    }

    return {
      root: rootVars,
    };
  },
});
